import { Component, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from '@unilog/ng9-table';
import { GeneralService } from 'src/app/services/general.service';


@Component({
  selector: 'app-tableau-statistique',
  templateUrl: './tableau-statistique.component.html',
  styleUrls: ['./tableau-statistique.component.scss'],
})
export class TableauStatistiqueComponent implements OnInit {
  @ViewChild('details') details;
  @ViewChild('bank') bank;
  @ViewChild('nature') nature;
  @ViewChild('tableComponent', { static: false })
  tableComponent: TableComponent;
  sortBy = 'day';
  dateDetailsMin;
  dateDetailsMax;
  data;
  filtredData;
  ech;
  listSoc;
  listBanks;
  listBanksToShow = [];
  allTypes;
  showTable = true;
  minDateAllowed: Date;
  maxDateAllowed: Date;
  maxDate: Date;
  minDate: Date;
  minDateInData;
  raportEchu;
  level = 3;
  insightData;
  detailsData;
  insightDataKeys;
  filterList = [];
  configs = {
    allowMultipleExpands: true,
    tableClass: 'min-w-max w-full table-auto',
    headerClass: 'bg-gray-200 text-gray-600 uppercase text-sm leading-normal',
    RowClass: ' hover:bg-gray-100',
    parentHeadersClass:
      'rounded-xl border  px-10 cursor-pointer font-bold py-4 text-lg capitalize',
    parentHeadersClassSelected: 'bg-red-500 text-white',
  };

  dateEncaismenmat = []
  dateSociete = []
  dateSocieteFirstTable = []
  datesocSum = []
  dataSource: any = [];
  constructor(private generaleService: GeneralService) { }

  ngOnInit() {
    this.generaleService.rechercheTable2('apiEncFin').subscribe(async (res) => {
      this.data = res;
      this.filtredData = [
        ...this.data.filter((line) => line != null && line.dateEch),
      ];

      // this.minDateAllowed = new Date(
      //   this.filtredData.reduce((a, b) =>
      //     new Date(a.dateEch) < new Date(b.dateEch) ? a : b
      //   ).dateEch
      // );
      this.minDate = new Date();
      this.minDate.setHours(0, 0, 0, 0);
      this.minDateAllowed = new Date();
      this.minDateAllowed.setHours(0, 0, 0, 0);
      this.minDateInData = new Date(
        this.filtredData.reduce((a, b) =>
          new Date(a.dateEch) < new Date(b.dateEch) ? a : b
        ).dateEch
      );

      this.maxDateAllowed = this.maxDate = new Date(
        this.filtredData.reduce((a, b) =>
          new Date(a.dateEch) > new Date(b.dateEch) ? a : b
        ).dateEch
      );
      //  ? get the 'socites' for filetring
      this.getSocietes();
      //  ? get the 'banque' for filtering
      this.listBanks = await this.getBanks();
      this.listBanksToShow = this.listBanks.map((e) => e.Nom);

      this.getTypes();

      // ? getting the level4 headers (days or semane or mounths)
      this.setupLevel4();
    });
  }

  setupSourceDataFirstTable() {
    let oldDataSource = [...this.dataSource];
    let dataSource = [];
    // ? group by societe
    let socGrouped: any = this.groupBy(this.filtredData, 'soc');
    console.log(socGrouped);
    // ? in each societe group by bank
    socGrouped = socGrouped.map((soc: Array<any>) =>
      this.groupBy(soc, 'banque')
      //.map((banque) => this.groupBy(banque, 'nature'))
    );
    console.log(socGrouped);

    // ? data is now looking like :
    // ? [    <= societe
    // ?    [{...}] <= Bank 1
    // ?    [{...}] <= Bank 2
    // ? ],

    socGrouped.forEach((soc: Array<any>, i) => {
      // ? for each soc we are adding a row
      dataSource.push({
        title: soc[0][0].soc,
        class: 'font-bold',
        expanded: oldDataSource.length != 0 ? oldDataSource[i].expanded : false, // ? the old expand state
        backGroundColor: 'white',
        //textColor: soc[0][0].nature == 1 ? '#13a13c' : '#f44336',
        data: [], // ? Latter on we gonna update this array with the sum of the childrens
        childs: soc.filter((b) => this.listBanksToShow.includes(b[0].banque))
          .map((bank, j) => {
            //console.log(banque);
            // ?  for each bank we gonna add a child object
            let distinctArr = [...new Set(bank.map((e) => e.type))];
            distinctArr = distinctArr.map((distictType) =>
              bank.find((e) => e.type == distictType)
            );
            return {
              title: bank[0].banque != '' ? bank[0].banque : 'NO_BANK',
              backgroundColor: 'white',
              // ? the old expand state
              expanded: false,
              data: [],// ? Latter on we gonna update this array with the sum of the details
              childs: this.allTypes.map((type: any) => {
                // ? after cleaning up the data we gonna add the detail row
                return {
                  title: type,
                  Cat: (
                    bank.find((type_) => type_.type == type) || { Cat: 1 }
                  ).Cat,
                  expanded: false,
                  data: this.dateSocieteFirstTable.map((date) => {
                    // ? get the details of this bank for this date
                    return (
                      bank.filter((type_) => {
                        if (this.sortBy == 'day')
                          return (
                            type_.type == type && // ? this bank
                            new Date(type_.dateEch).toString() == // ? this date
                            new Date(date.title).toString()
                          );
                        else if (this.sortBy == 'mounth') {
                          let lastDayOfMonth = new Date(
                            new Date(date.title).getFullYear(),
                            new Date(date.title).getMonth() + 1,
                            0
                          );
                          // // ? first date
                          // if (
                          //   new Date(this.minDate).toString() ==
                          //   new Date(date.title).toString()
                          // ) {
                          //   return (
                          //     type_.type == type &&
                          //     new Date(this.minDate) <
                          //       new Date(type_.dateEch) &&
                          //     new Date(type_.dateEch) < lastDayOfMonth
                          //   );
                          // }
                          // ? else return this mounth's data
                          return (
                            type_.type == type && // ? this bank
                            new Date(type_.dateEch).getMonth() == // ? this date
                            new Date(date.title).getMonth() &&
                            new Date(type_.dateEch).getFullYear() == // ? this date
                            new Date(date.title).getFullYear()
                          );
                        }

                        return 0;
                      }) || [{ montant: 0, nature: 1 }]
                    ).reduce(
                      (
                        a,
                        b // ? sum
                      ) =>
                        (Number(a) + Number(b.montant) * b.nature).toFixed(
                          3
                        ),
                      0
                    );
                  }),
                };
              }),
            }
          })
      })
      // ? All banks should be visible so if one bank is missing we add it
      this.listBanksToShow.forEach((bank) => {
        //console.log(bank);
        dataSource.forEach((n) => {
          if (!n.childs.map((b) => b.title).includes(bank))
            n.childs.push({
              title: bank,
              class:
                n.title == 1
                  ? 'text-green-700  font-bold'
                  : 'text-red-700 font-bold',
              backgroundColor: 'white',
              expanded: false,
              data: this.dateSocieteFirstTable.map(() => 0),
              childs: [],
            });
        });
      });
      // ? summing the banks rows
      dataSource[dataSource.length - 1].childs.forEach((soc) => {
        soc.data = [...this.dateSocieteFirstTable].map((_, dayIndex) => {
          return Number(
            soc.childs
              .map((detail) => detail.data[dayIndex])
              .reduce((a, b) => a + Number(b), 0)
              .toFixed(3)
          );
        });

      });
      // ? summing the soc row
      dataSource[dataSource.length - 1].childs.forEach((soc) => {
        soc.data = [...this.dateSocieteFirstTable].map((_, dayIndex) => {
          return Number(
            soc.childs
              .map((child) => child.data[dayIndex])
              .reduce((a, b) => a + Number(b), 0)
              .toFixed(3)
          );
        });
      });
      // ? summing the nature rows
      dataSource[dataSource.length - 1].data = [...this.dateSocieteFirstTable].map(
        (_, dayIndex) => {
          return Number(
            dataSource[dataSource.length - 1].childs
              .map((child) => child.data[dayIndex])
              .reduce((a, b) => a + Number(b), 0)
              .toFixed(3)
          );
        }
      );
    })

    this.dataSourceFirstTable = dataSource;
    // ? For the first Column "Echu"
    this.setUpFirstTable();
    // ? remove the lines if it full of zeros
    dataSource.forEach((soc) =>
      soc.childs.forEach((bank) => {
        if (bank.childs) {
          bank.childs = bank.childs.filter(
            (detail) => !detail.data.every((val, i, arr) => val === arr[0])
          );
        }
        soc.childs = soc.childs.filter(
          (b) => !b.data.every((val, i, arr) => val === arr[0])
        );
      })
    );
    dataSource.forEach(element => {
      element.childs.unshift({
        title: element.title + ' Prévisionnel',
        class: '',
        expanded: false,
        backGroundColor: 'white',
        textColor: '#412234',
        data: this.SommePerDate(dataSource, element.title, 'COFFRE'),
        show: this.sommeTab(this.SommePerDate(dataSource, element.title, 'COFFRE')),
        childs: this.otherLane(dataSource, element.title, 'COFFRE'),
      }, {
        title: element.title + ' Réel',
        class: '',
        expanded: false,
        backGroundColor: 'white',
        textColor: '#412234',
        data: this.findData(dataSource, element.title, 'COFFRE'),
        show: this.sommeTab(this.findData(dataSource, element.title, 'COFFRE')),
        childs: this.findChilds(dataSource, element.title, 'COFFRE'),
      })

    });
    dataSource.forEach(element => {
      element.childs.splice(2)
    });
    console.log(dataSource);
    dataSource.forEach(element => {
      element['data'] = this.sommeBefore(element['data'])
    });
    console.log(dataSource);

    this.dataSourceFirstTable = dataSource
  }
  sommeBefore(dataSource) {
    let tab = []
    dataSource.forEach((element, index) => {

      if (index >= 1)
        tab.push(this.calculSomme(dataSource, index))
      else
        tab.push(element)
    });
    return tab
  }
  calculSomme(data, index) {
    let s = 0
    for (let i = 0; i <= index; i++) {
      s = s + data[i]
    }
    return s
  }
  sommeTab(tab) {
    let s = 0
    tab.forEach(element => {
      s += element
    });
    if (s == 0)
      return false
    else
      return true

  }
  otherLane(dataSource, title, notAllowed) {
    let tab = []
    dataSource.forEach(soc => {
      if (soc.title == title) {
        soc.childs.forEach(type => {
          if (type.title != notAllowed) {
            tab.push(type)
          }
        });
      }
    })
    return tab
  }
  SommePerDate(dataSource, title, value) {
    let tab = []
    dataSource.forEach(soc => {
      if (soc.title == title) {
        soc.childs.forEach(element => {
          if (element.title == value) {
            tab.push(element.data)
          }
        });
      }
    });
    let finalTab = []
    if (tab.length != 0) {
      if (tab[0].length != 0) {
        for (let i = 0; i < tab[0].length; i++) {
          let s = 0
          for (let j = 0; j < tab.length; j++) {
            s += tab[j][i]
          }
          finalTab.push(s)
        }
      }
    }
    else {
      finalTab = [0, 0, 0, 0, 0, 0, 0, 0]
    }
    return finalTab
  }
  findData(dataSource, name, name2) {
    // console.log(dataSource);
    // console.log(name);
    // console.log(name2);

    if (dataSource.find(e => e.title == name).childs.find(type => type.title == name2))
      return dataSource.find(e => e.title == name).childs.find(type => type.title == name2).data
    else
      return []
  }
  findChilds(dataSource, name, name2) {
    if (dataSource.find(e => e.title == name).childs.find(type => type.title == name2))
      return dataSource.find(e => e.title == name).childs.find(type => type.title == name2).childs
    else
      return []
  }
  dataSourceFirstTable
  setupSourceData() {
    let oldDataSource = [...this.dataSource];
    let dataSource = [];
    // ? group by societe
    console.log("filtredData", this.filtredData);
    let socGrouped: any = this.groupBy(this.filtredData, 'soc');
    console.log(socGrouped);
    socGrouped = socGrouped.map((soc: Array<any>) =>
      this.groupBy(soc, 'prev')
    );

    // ? in each societe group by bank
    socGrouped = socGrouped.map((soc: Array<any>) =>
      soc.map((prev: Array<any>) =>
        this.groupBy(prev, 'banque'))
      //.map((banque) => this.groupBy(banque, 'nature'))
    );
    console.log(socGrouped);

    // ? data is now looking like :
    // ? [    <= societe
    // ?    [{...}] <= Bank 1
    // ?    [{...}] <= Bank 2
    // ? ],

    socGrouped.forEach((soc: Array<any>, i) => {
      dataSource.push({
        title: soc[0][0][0].soc,
        class: 'font-bold',
        expanded: oldDataSource.length != 0 ? oldDataSource[i].expanded : false, // ? the old expand state
        backGroundColor: 'white',
        //textColor: soc[0][0].nature == 1 ? '#13a13c' : '#f44336',
        data: [], // ? Latter on we gonna update this array with the sum of the childrens
        childs: []
      })
      soc.forEach((prev: Array<any>, j) => {
        // ? for each soc we are adding a row
        dataSource.push({
          title: prev[0][0].soc,
          class: 'font-bold',
          prev: prev[0][0].prev,
          expanded: oldDataSource.length != 0 ? oldDataSource[i].expanded : false, // ? the old expand state
          backGroundColor: 'white',
          //textColor: soc[0][0].nature == 1 ? '#13a13c' : '#f44336',
          data: [], // ? Latter on we gonna update this array with the sum of the childrens
          childs: prev.filter((b) => this.listBanksToShow.includes(b[0].banque))
            .map((bank, j) => {
              //console.log(banque);
              // ?  for each bank we gonna add a child object
              let distinctArr = [...new Set(bank.map((e) => e.type))];
              distinctArr = distinctArr.map((distictType) =>
                bank.find((e) => e.type == distictType)
              );
              return {
                title: bank[0].banque != '' ? bank[0].banque : 'NO_BANK',
                backgroundColor: 'white',
                // ? the old expand state
                expanded:
                  oldDataSource.length != 0
                    ? oldDataSource[i].childs[j] != null
                      ? oldDataSource[i].childs[j].expanded || false
                      : false
                    : false,
                data: [],// ? Latter on we gonna update this array with the sum of the details
                childs: this.allTypes.map((type: any) => {
                  // ? after cleaning up the data we gonna add the detail row
                  return {
                    title: type,
                    Cat: (
                      bank.find((type_) => type_.type == type) || { Cat: 1 }
                    ).Cat,
                    data: this.dateSociete.map((date) => {
                      // ? get the details of this bank for this date
                      return (
                        bank.filter((type_) => {
                          if (this.sortBy == 'day')
                            return (
                              type_.type == type && // ? this bank
                              new Date(type_.dateEch).toString() == // ? this date
                              new Date(date.title).toString()
                            );
                          else if (this.sortBy == 'mounth') {
                            let lastDayOfMonth = new Date(
                              new Date(date.title).getFullYear(),
                              new Date(date.title).getMonth() + 1,
                              0
                            );
                            // // ? first date
                            // if (
                            //   new Date(this.minDate).toString() ==
                            //   new Date(date.title).toString()
                            // ) {
                            //   return (
                            //     type_.type == type &&
                            //     new Date(this.minDate) <
                            //       new Date(type_.dateEch) &&
                            //     new Date(type_.dateEch) < lastDayOfMonth
                            //   );
                            // }
                            // ? else return this mounth's data
                            return (
                              type_.type == type && // ? this bank
                              new Date(type_.dateEch).getMonth() == // ? this date
                              new Date(date.title).getMonth() &&
                              new Date(type_.dateEch).getFullYear() == // ? this date
                              new Date(date.title).getFullYear()
                            );
                          }

                          return 0;
                        }) || [{ montant: 0, nature: 1 }]
                      ).reduce(
                        (
                          a,
                          b // ? sum
                        ) =>
                          (Number(a) + Number(b.montant) * b.nature).toFixed(
                            3
                          ),
                        0
                      );
                    }),
                  };
                }),
              }
            })
        })
        // ? All banks should be visible so if one bank is missing we add it
        this.listBanksToShow.forEach((bank) => {
          //console.log(bank);
          dataSource.forEach((n) => {
            if (!n.childs.map((b) => b.title).includes(bank))
              n.childs.push({
                title: bank,
                class:
                  n.title == 1
                    ? 'text-green-700  font-bold'
                    : 'text-red-700 font-bold',
                backgroundColor: 'white',
                expanded: false,
                data: this.dateSociete.map(() => 0),
                childs: [],
              });
          });
        });
        // ? summing the banks rows
        dataSource[dataSource.length - 1].childs.forEach((soc) => {
          soc.data = [...this.dateSociete].map((_, dayIndex) => {
            return Number(
              soc.childs
                .map((detail) => detail.data[dayIndex])
                .reduce((a, b) => a + Number(b), 0)
                .toFixed(3)
            );
          });

        });
        // ? summing the soc row
        dataSource[dataSource.length - 1].childs.forEach((soc) => {
          soc.data = [...this.dateSociete].map((_, dayIndex) => {
            return Number(
              soc.childs
                .map((child) => child.data[dayIndex])
                .reduce((a, b) => a + Number(b), 0)
                .toFixed(3)
            );
          });
        });
        // ? summing the nature rows
        dataSource[dataSource.length - 1].data = [...this.dateSociete].map(
          (_, dayIndex) => {
            return Number(
              dataSource[dataSource.length - 1].childs
                .map((child) => child.data[dayIndex])
                .reduce((a, b) => a + Number(b), 0)
                .toFixed(3)
            );
          }
        );
      })
    })


    this.dataLastTable = dataSource;
    // ? For the first Column "Echu"
    this.setUp();

    dataSource = this.generateDataSource(dataSource)

    // ? report
    dataSource.unshift({
      title: 'Solde Initial',
      class: '',
      expanded: false,
      backGroundColor: 'white',
      textColor: '#656565',
      data: this.dateSociete.map(() => 0),
      childs: [],
    });

    // ? total
    dataSource.push({
      title: 'Total Mouvement',
      class: 'none',
      expanded: false,
      backGroundColor: 'white',
      textColor: '#59347e',
      data: this.dateSociete.map((date, dateIndex) => {
        return Number(
          this.sommeEachSociete(dataSource, dateIndex)
        );
      }),
      childs: [],
    });

    // ? solde
    dataSource.push({
      title: 'Solde Final',
      class: 'none',
      expanded: false,
      backGroundColor: 'white',
      textColor: '#412234',
      data: this.dateSociete.map(() => 0),
      childs: [],
    });

    this.dateSociete.forEach((date, dateIndex) => {
      // ? report
      dataSource[0].data[dateIndex] =
        dataSource[dataSource.length - 1].data[dateIndex - 1] || 0;

      dataSource[dataSource.length - 1].data[dateIndex] = Number(
        dataSource[0].data[dateIndex] +
        Number(dataSource[dataSource.length - 2].data[dateIndex])
      );
    });

    // ? remove the lines if it full of zeros
    dataSource.forEach((soc) =>
      soc.childs.forEach((bank) => {
        if (bank.childs) {
          bank.childs = bank.childs.filter(
            (detail) => !detail.data.every((val, i, arr) => val === arr[0])
          );
        }
        soc.childs = soc.childs.filter(
          (b) => !b.data.every((val, i, arr) => val === arr[0])
        );
      })
    );
    console.log(dataSource);

    dataSource.forEach(element => {
      if (element.title != 'Solde Final' && element.title != 'Total Mouvement' && element.title != 'Solde Initial')
        element['data'] = this.sommeBefore(element['data'])
    });
    // dataSource[dataSource.length-3].data[0]=this.sumFirstTable
    // dataSource[dataSource.length-2].data[0]=this.sumFirstColTable2
    this.dataLastTable = dataSource
    console.log(this.dataLastTable);
  }
  generateDataSource(dataSource) {
    return this.sommeChild(this.filterData(this.addChild(dataSource)))
  }
  sommeChild(dataSource) {
    dataSource.forEach((soc) => {
      soc.data = this.sommeDataChild(soc.childs)
      soc.title='Solde Final Prévisionnel '+soc.title
      soc.childs.forEach(child => {
        if (child.prev == 1) {
          child.title = 'Total Mouvements Prévisionnel '+ child.title 
        }
        else {
          child.title = 'Solde Final Réel '+child.title 
        }
      });
    })
    return dataSource
  }
  addChild(dataSource) {
    dataSource.forEach(soc => {
      if (soc.prev == undefined) {
        soc.childs = dataSource.filter(child => child.prev != undefined && child.title == soc.title)
      }
    })
    return dataSource
  }
  filterData(dataSource) {
    return dataSource.filter(child => child.prev == undefined)
  }
  sommeDataChild(tab) {
    var finalTab = []
    console.log(tab);

    if (tab.length != 0) {
      if (tab.length == 1)
        return tab[0].data
      else
        if (tab[0].data.length != 0) {
          let s = 0
          for (let i = 0; i < tab[0].data.length; i++) {
            s += tab[0].data[i] + tab[1].data[i]
            finalTab.push(s)
            s = 0
          }
        }
    }
    else
      finalTab = [0, 0, 0, 0, 0, 0, 0, 0]
    // tab.forEach((element) => {
    //   element.data.forEach((el, i) => {
    //     if (i == index)
    //       s += el
    //   });
    // });
    return finalTab
  }
  dataLastTable
  dataSecondeTable
  sommeEachSociete(dataSource, dateIndex) {
    let s = 0
    dataSource.forEach((element) => {
      if (element.title != 'Solde Initial') {
        s += element.data[dateIndex]
      }
    });
    return s
  }

  setupSourceData1() {
    let oldDataSource = [...this.dataSource];
    let dataSource = [];
    // ? group by nature (Encaissement | Décaissement)
    let natureGrouped: any = this.groupBy(this.filtredData, 'nature');
    console.log(natureGrouped);
    // natureGrouped = natureGrouped.map((soc: Array<any>) =>
    //   this.groupBy(soc, 'prev')
    // );
    // console.log(natureGrouped);
    // ? in each nature group by bank
    natureGrouped = natureGrouped.map((nature: Array<any>) =>
      this.groupBy(nature, 'soc').map((soc) => this.groupBy(soc, 'banque'))
    );
    console.log(natureGrouped);

    // ? data is now looking like :
    // ? [    <= Encaissement
    // ?    [{...}] <= Bank 1
    // ?    [{...}] <= Bank 2
    // ? ],
    // ? [    <= Décaissement
    // ?   [{...}] <= Bank 1
    // ? ]

    natureGrouped.forEach((nature: Array<any>, i) => {
      // ? for each nature we are adding a row

      dataSource.push({
        title: nature[0][0][0].nature == 1 ? 'Encaissement' : 'Décaissement',
        class: 'font-bold',
        expanded: oldDataSource.length != 0 ? oldDataSource[i].expanded : false, // ? the old expand state
        backGroundColor: 'white',
        textColor: nature[0][0][0].nature == 1 ? '#13a13c' : '#f44336',
        data: [], // ? Latter on we gonna update this array with the sum of the childrens
        childs: nature.map((soc, j) => {
          return {
            title: soc[0][0].soc || 'none',
            class:
              nature[0][0][0].nature == 1
                ? 'text-green-700  font-bold '
                : 'text-red-700 font-bold',
            backgroundColor: 'white',
            // ? the old expand state
            expanded:
              oldDataSource.length != 0
                ? oldDataSource[i].childs[j] != null
                  ? oldDataSource[i].childs[j].expanded || false
                  : false
                : false,
            data: [], // ? Latter on we gonna update this array with the sum of the details
            childs: soc
              .filter((b) => this.listBanksToShow.includes(b[0].banque))
              .map((bank, j) => {
                // ?  for each bank we gonna add a child object
                let distinctArr = [...new Set(bank.map((e) => e.type))];
                distinctArr = distinctArr.map((distictType) =>
                  bank.find((e) => e.type == distictType)
                );

                return {
                  title: bank[0].banque != '' ? bank[0].banque : 'NO_BANK',
                  class:
                    nature[0][0][0].nature == 1
                      ? 'text-green-700  font-bold  border-blue-600'
                      : 'text-red-700 font-bold  border-blue-600',
                  backgroundColor: 'white',
                  // ? the old expand state
                  expanded:
                    oldDataSource.length != 0
                      ? oldDataSource[i].childs[j] != null
                        ? oldDataSource[i].childs[j].expanded || false
                        : false
                      : false,
                  data: [], // ? Latter on we gonna update this array with the sum of the details
                  details: this.allTypes.map((type: any) => {
                    // ? after cleaning up the data we gonna add the detail row
                    return {
                      title: type,
                      Cat: (
                        bank.find((type_) => type_.type == type) || { Cat: 1 }
                      ).Cat,
                      data: this.dateEncaismenmat.map((date) => {
                        // ? get the details of this bank for this date
                        return (
                          bank.filter((type_) => {
                            if (this.sortBy == 'day')
                              return (
                                type_.type == type && // ? this bank
                                new Date(type_.dateEch).toString() == // ? this date
                                new Date(date.title).toString()
                              );
                            else if (this.sortBy == 'mounth') {
                              let lastDayOfMonth = new Date(
                                new Date(date.title).getFullYear(),
                                new Date(date.title).getMonth() + 1,
                                0
                              );

                              // // ? first date
                              // if (
                              //   new Date(this.minDate).toString() ==
                              //   new Date(date.title).toString()
                              // ) {
                              //   return (
                              //     type_.type == type &&
                              //     new Date(this.minDate) <
                              //       new Date(type_.dateEch) &&
                              //     new Date(type_.dateEch) < lastDayOfMonth
                              //   );
                              // }
                              // ? else return this mounth's data
                              return (
                                type_.type == type && // ? this bank
                                new Date(type_.dateEch).getMonth() == // ? this date
                                new Date(date.title).getMonth() &&
                                new Date(type_.dateEch).getFullYear() == // ? this date
                                new Date(date.title).getFullYear()
                              );
                            }

                            return 0;
                          }) || [{ montant: 0, nature: 1 }]
                        ).reduce(
                          (
                            a,
                            b // ? sum
                          ) =>
                            (Number(a) + Number(b.montant) * b.nature).toFixed(
                              3
                            ),
                          0
                        );
                      }),
                    };
                  }),
                };
              }),
          };
        }),
      });

      // ? All banks should be visible so if one bank is missing we add it
      this.listBanksToShow.forEach((bank) => {
        dataSource.forEach((n) => {
          n.childs.forEach((s) => {
            if (!s.childs.map((b) => b.title).includes(bank))
              s.childs.push({
                title: bank,
                class:
                  n.title == 1
                    ? 'text-green-700  font-bold'
                    : 'text-red-700 font-bold',
                backgroundColor: 'white',
                expanded: false,
                data: this.dateEncaismenmat.map(() => 0),
                details: [],
              });
          });
        });
      });
      // ? summing the banks rows
      dataSource[dataSource.length - 1].childs.forEach((soc) => {
        soc.childs.forEach((bank) => {
          bank.data = [...this.dateEncaismenmat].map((_, dayIndex) => {
            return Number(
              bank.details
                .map((detail) => detail.data[dayIndex])
                .reduce((a, b) => a + Number(b), 0)
                .toFixed(3)
            );
          });
        });
      });
      // ? summing the soc row

      dataSource[dataSource.length - 1].childs.forEach((soc) => {
        soc.data = [...this.dateEncaismenmat].map((_, dayIndex) => {
          return Number(
            soc.childs
              .map((child) => child.data[dayIndex])
              .reduce((a, b) => a + Number(b), 0)
              .toFixed(3)
          );
        });
      });

      // ? summing the nature rows
      dataSource[dataSource.length - 1].data = [...this.dateEncaismenmat].map(
        (_, dayIndex) => {
          return Number(
            dataSource[dataSource.length - 1].childs
              .map((child) => child.data[dayIndex])
              .reduce((a, b) => a + Number(b), 0)
              .toFixed(3)
          );
        }
      );
    });
    console.log(dataSource);
    // ? we effect the data to the global variable because "setUpEch()" function use it
    this.dataSecondeTable = dataSource;


    // ? For the first Column "Echu"
    this.setUpEch();
    // ? remove the lines if it full of zeros
    dataSource.forEach((nature) =>
      nature.childs.forEach((soc) => {
        soc.childs.forEach((bank) => {
          bank.details = bank.details.filter(
            (detail) => !detail.data.every((val, i, arr) => val === arr[0])
          );
        });

        soc.childs = soc.childs.filter(
          (b) => !b.data.every((val, i, arr) => val === arr[0])
        );
      })
    );
    this.sumFirstColTable2 = 0
    dataSource.forEach(element => {
      this.sumFirstColTable2 += element.data[0]
    });
    this.dataSecondeTable = dataSource;
    console.log(this.dataSecondeTable);
  }
  sumFirstColTable2
  async getBanks() {
    return await this.generaleService.rechercheTable2('apiBanque').toPromise();
  }
  getSocietes() {
    this.generaleService
      .rechercheTable2('apiSoc')
      .subscribe((res) => (this.listSoc = res));
  }

  groupBy(items, key) {
    return Object.values(
      items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      )
    );
  }
  groupByPrev(items, key) {
    return Object.values(
      items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      )
    );
  }

  checkFilter(event, code, type) {
    if (!event) {
      const elIndex = this.filterList.map((e) => e.code).indexOf(code);
      if (elIndex != -1) this.filterList.splice(elIndex, 1);
    } else this.filterList.push({ code, type });

    this.updateFilter();
  }
  updateFilter(key?) {
    // ? clearing the filter
    if (key) this.filterList = this.filterList.filter((el) => el.type != key);

    /**
     * ! the lisSoc is the filter for socites and it change the JSON directly (the JSON from the api)
     * ! meanwhile the listBanksToShow does only change the dataSource variable (the object responsable for the UI )
     */
    if (this.filterList.length == 0) {
      this.filtredData = [
        ...this.data.filter(
          (line) => line != null && line.dateEch && line.nature
        ),
      ];
      this.listBanksToShow = this.listBanks.map((e) => e.Nom);
    } else {
      let validData = [
        ...this.data.filter(
          (line) => line != null && line.dateEch && line.nature
        ),
      ];

      const lisSoc = this.filterList
        .filter((l) => l.type == 'soc')
        .map((soc) => soc.code);
      const listB = this.filterList
        .filter((l) => l.type == 'bank')
        .map((bank) => bank.code);

      if (lisSoc.length != 0)
        this.filtredData = validData.filter((line) =>
          lisSoc.includes(line.soc)
        );

      if (listB.length != 0) this.listBanksToShow = listB;
      else {
        this.listBanksToShow = this.listBanks.map((e) => e.code);
      }
    }

    this.setupLevel4();
  }
  exsistInFilter(code) {
    return this.filterList.find((e) => e.code == code) != null;
  }
  setupLevel4() {
    // ? we simply set the headers with the minDate and the 6 days after it
    let newArr = [];
    let newArrfirst = [];
    let d: Date = new Date(this.minDate);
    // .getTime() - 1000 * 3600 * 24
    let dayFirstTable
    if (this.sortBy == "mounth")
      dayFirstTable = new Date(this.minDate)
    else
      dayFirstTable = new Date(this.minDate.getTime() - 1000 * 3600 * 24)
    newArr[0] = {
      title: new Date(d),
      selected: true,
    };

    newArrfirst[0] = {
      title: new Date(dayFirstTable),
      selected: true,
    };

    console.log(d);
    console.log(dayFirstTable);
    for (let i = 0; i < 7; i++) {
      if (this.sortBy == 'day') dayFirstTable.setDate(dayFirstTable.getDate() + 1);
      else if (this.sortBy == 'mounth' && i > 0) {
        dayFirstTable.setDate(1);
        dayFirstTable.setMonth(dayFirstTable.getMonth() + 1);
      }

      newArrfirst[i] = {
        title: new Date(dayFirstTable),
        selected: true,
      };
    }

    for (let i = 0; i < 7; i++) {
      if (this.sortBy == 'day') d.setDate(d.getDate() + 1);
      else if (this.sortBy == 'mounth' && i > 0) {
        d.setDate(1);
        d.setMonth(d.getMonth() + 1);
      }

      newArr[i] = {
        title: new Date(d),
        selected: true,
      };
    }

    console.log(...newArr);
    console.log(...newArrfirst);
    this.dateSocieteFirstTable = [...newArrfirst];
    this.dateSociete = [...newArr];
    this.dateEncaismenmat = [...newArr];
    this.datesocSum = [...newArr];

    this.dateDetailsMin = null;
    this.dateDetailsMax = null;
    this.insightData = [];
    // * the datasource (ALL THE MAGIC GOES IN HERE)
    this.setupSourceDataFirstTable()
    this.setupSourceData1();
    this.setupSourceData();
    // ? we blink to update the UI
    // ! IF YOU DON'T BLINK THE LEVEL4 ( DATES ) WONT CHANGE
    this.blink();
  }
  setMinDate(daysToAdd) {
    if (this.sortBy == 'day') {
      if (daysToAdd == 1)
        // ? find next monday
        this.minDate.setDate(
          this.minDate.getDate() + ((7 - this.minDate.getDay()) % 7 || 7)
        );
      // ? find prev monday
      else
        this.minDate.setDate(
          this.minDate.getDate() - ((7 - this.minDate.getDay()) % 7 || 7)
        );
    } else if (this.sortBy == 'mounth') {
      this.minDate.setMonth(this.minDate.getMonth() + daysToAdd);
      this.minDate.setDate(1);
    }
    this.setupLevel4();
  }
  findAll(list, soc, bank) {
    var listP
    listP = list.find(eSoc => eSoc[0][0][0].soc ? eSoc[0][0][0].soc == soc.title && soc.prev == eSoc[0][0][0].prev : []
      || eSoc[0][1][0].soc ? eSoc[0][1][0].soc == soc.title && soc.prev == eSoc[0][1][0].prev : []
    )
    var l
    l = listP && listP.find((eBank) => eBank.find(prev => prev[0].prev == soc.prev)) ? listP.find((eBank) => eBank.find(prev => prev[0].prev == soc.prev && prev[0].montant > 0)) : []
    var b
    b = l && l.find((eBank) => eBank[0].banque == bank.title) ? l.find((eBank) => eBank[0].banque == bank.title && eBank[0].montant != 0) : []
    // var x
    // x = b && b.find((e => e[0].prev == soc.prev)) ? b.find((e => e[0].prev == soc.prev  )) : []
    console.log(soc);
    console.log(listP);
    console.log(l);
    console.log(bank.title);
    console.log(typeof (bank.title));
    console.log(b);

    return b
  }
  // setUp1() {
  //   let echData = this.filtredData.filter(
  //     (e) => new Date(e.dateEch) <= this.minDate
  //   );

  //   echData = this.groupBy(echData, 'soc');
  //   echData = echData.map((soc: Array<any>) =>
  //     this.groupBy(soc, 'prev')
  //   );
  //   echData = echData.map((prev: Array<any>) =>
  //     this.groupBy(prev, 'banque')
  //   );
  //   console.log("Dataa", echData);

  //   if (echData.length == 0) return;
  //   // ? we add the ECHU collumn
  //   this.dateSociete.unshift({ title: this.minDate, selected: false });
  //   console.log(this.dataLastTable);

  //   this.dataLastTable.forEach((soc) => {
  //     if (soc.prev != undefined)
  //       soc.childs.forEach((bank) => {
  //         if (bank.childs) {
  //           bank.childs.forEach((type) => {
  //             console.log("aezaeaze", type);

  //             type.data.unshift(
  //               this.findAll(echData, soc, bank)
  //                 .filter((line) => {
  //                   // console.log(line);
  //                   //   //? we get all the lines (from the JSON) and find this spicefic line (UI) and sum them
  //                   return line.type == type.title && soc.title == line.soc;

  //                 })
  //                 .reduce((a, b) => (a + Number(b.montant * Number(b.nature))), 0)
  //             );
  //           });
  //         }

  //         //? the that we have the details calculated we can simply calculate the higher levels (bank / encaissement)
  //         bank.data.unshift(
  //           // ? bank
  //           bank.childs
  //             .map((type) => type.data[0])
  //             .reduce((a, b) => a + Number(b), 0) || 0
  //         );
  //       });
  //     soc.data.unshift(
  //       soc.childs
  //         .map((bank) => bank.data[0])
  //         .reduce((a, b) => a + Number(b), 0) || 0
  //     );
  //   });
  // }
  setUp() {
    let echData = this.filtredData.filter(
      (e) => (new Date(e.dateEch) <= this.minDate && e.montant != 0)
    );

    echData = this.groupBy(echData, 'soc');
    echData = echData.map((soc: Array<any>) =>
      this.groupBy(soc, 'banque')
      //.map((banque) => this.groupBy(banque, 'nature'))
    );

    if (echData.length == 0) return;
    // ? we add the ECHU collumn
    this.dateSociete.unshift({ title: this.minDate, selected: false });

    this.dataLastTable.forEach((soc) => {
      soc.childs.forEach((bank) => {
        if (bank.childs) {
          bank.childs.forEach((type) => {
            type.data.unshift(
              (
                (echData.find((eSoc) => eSoc[0][0].soc == soc.title) || []).find((eBank) => eBank[0].banque == bank.title && eBank[0].prev == soc.prev) || []
              )
                .filter((line) => {
                  //   //? we get all the lines (from the JSON) and find this spicefic line (UI) and sum them
                  return line.type == type.title && soc.title == line.soc;
                })
                .reduce((a, b) => (a + Number(b.montant * Number(b.nature))), 0)
            );
          });
        }
        //? the that we have the details calculated we can simply calculate the higher levels (bank / encaissement)
        bank.data.unshift(
          // ? bank
          bank.childs
            .map((type) => type.data[0])
            .reduce((a, b) => a + Number(b), 0) || 0
        );
      });
      soc.data.unshift(
        soc.childs
          .map((bank) => bank.data[0])
          .reduce((a, b) => a + Number(b), 0) || 0
      );
    });
  }
  setUpFirstTable() {

    let echData = this.filtredData.filter(
      (e) => new Date(e.dateEch) <= new Date(this.minDate.getTime() - 1000 * 3600 * 24)
    );

    echData = this.groupBy(echData, 'soc');


    echData = echData.map((soc: Array<any>) =>
      this.groupBy(soc, 'banque')
      //.map((banque) => this.groupBy(banque, 'nature'))
    );
    console.log(echData);

    if (echData.length == 0) return;
    // ? we add the ECHU collumn
    this.dateSocieteFirstTable.unshift({ title: new Date(this.minDate.getTime() - 1000 * 3600 * 24), selected: false });

    this.dataSourceFirstTable.forEach((soc) => {
      soc.childs.forEach((bank) => {
        if (bank.childs) {
          bank.childs.forEach((type) => {
            type.data.unshift(
              (
                (echData.find((eSoc) => eSoc[0][0].soc == soc.title) || []).find((eBank) => eBank[0].banque == bank.title) || []
              )
                .filter((line) => {
                  //   //? we get all the lines (from the JSON) and find this spicefic line (UI) and sum them
                  return line.type == type.title && soc.title == line.soc;
                })
                .reduce((a, b) => (a + Number(b.montant * Number(b.nature))), 0)
            );
          });
        }
        //? the that we have the details calculated we can simply calculate the higher levels (bank / encaissement)
        bank.data.unshift(
          // ? bank
          bank.childs
            .map((type) => type.data[0])
            .reduce((a, b) => a + Number(b), 0) || 0
        );
      });
      soc.data.unshift(
        soc.childs
          .map((bank) => bank.data[0])
          .reduce((a, b) => a + Number(b), 0) || 0
      );
    });
    console.log(this.dataSourceFirstTable);
    this.sumFirstTable = 0
    this.dataSourceFirstTable.forEach(element => {
      this.sumFirstTable += element.data[0]
    });


  }
  sumFirstTable
  setUpEch() {
    // ? remove unwanted dates
    // this.filtredData = [
    //   ...this.data.filter((line) => line != null && line.dateEch),
    // ].filter((e) => new Date(e.dateEch) < this.maxDate);
    let echData = this.filtredData.filter(
      (e) => new Date(e.dateEch) <= this.minDate
    );
    // let echData = this.filtredData.filter(
    //   (e) => new Date(e.dateEch).toISOString() == this.minDate.toISOString()
    // );

    // ? useless (for debuging)
    // this.raportEchu = echData.reduce(
    //   (a, b) => a + Number(b.montant) * b.nature,
    //   0
    // );

    echData = this.groupBy(echData, 'nature');

    // ? in each nature group by bank
    echData = echData.map((nature: Array<any>) =>
      this.groupBy(nature, 'soc').map((soc) => this.groupBy(soc, 'banque'))
    );

    if (echData.length == 0) return;
    let Encaissement = echData.find((e) => e[0][0][0].nature == 1) || [];
    let Decaissement = echData.find((e) => e[0][0][0].nature == -1) || [];

    // ? we add the ECHU collumn
    this.dateEncaismenmat.unshift({ title: this.minDate, selected: false });

    this.dataSecondeTable.forEach((nature) => {
      let arrayOfFilter =
        nature.title == 'Décaissement' ? Decaissement : Encaissement;
      console.log(arrayOfFilter);

      let curr = nature.title == 'Décaissement' ? -1 : 1;
      nature.childs.forEach((soc) => {
        soc.childs.forEach((bank) => {
          bank.details.forEach((type) => {
            type.data.unshift(
              (
                (
                  arrayOfFilter.find((eSoc) => eSoc[0][0].soc == soc.title) ||
                  []
                ).find((eBank) => eBank[0].banque == bank.title) || []
              )
                .filter((line) => {
                  //? we get all the lines (from the JSON) and find this spicefic line (UI) and sum them
                  return line.type == type.title && soc.title == line.soc;
                })
                .reduce((a, b) => a + Number(b.montant), 0) * curr
            );
          });

          //? the that we have the details calculated we can simply calculate the higher levels (bank / encaissement)
          bank.data.unshift(
            // ? bank
            bank.details
              .map((type) => type.data[0])
              .reduce((a, b) => a + Number(b), 0) || 0
          );
        });
        soc.data.unshift(
          soc.childs
            .map((bank) => bank.data[0])
            .reduce((a, b) => a + Number(b), 0) || 0
        );
      });
      nature.data.unshift(
        // ? encaissement
        nature.childs
          .map((soc) => soc.data[0])
          .reduce((a, b) => a + Number(b), 0) || 0
      );
    });
  }
  getTypes() {
    this.allTypes = Array.from(new Set(this.filtredData.map((e) => e.type)));
  }
  blink() {
    this.showTable = false;
    setTimeout(() => {
      this.showTable = true;
    }, 1);
  }
  presentDetailsModal(event) {
    const formatDate = (date) => {
      return (
        date.getFullYear() +
        '' +
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        '' +
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
      );
    };

    const colDate: Date = new Date(event.col.col.title);
    let dateDebut = colDate;
    if (event.col.isEchu) {
      this.dateDetailsMin = this.minDateInData;
      this.dateDetailsMax = dateDebut;
      var dateDeb = formatDate(this.minDateInData);
      var dateFin = formatDate(colDate);
    } else if (this.sortBy == 'mounth') {
      this.dateDetailsMin = dateDebut;
      this.dateDetailsMax = new Date(
        dateDebut.getFullYear(),
        dateDebut.getMonth() + 1,
        0
      );
      var dateDeb = formatDate(dateDebut);
      var dateFin = formatDate(this.dateDetailsMax);
    } else if (this.sortBy == 'day') {
      this.dateDetailsMin = dateDebut;
      var dateDeb = formatDate(dateDebut);
      var dateFin = formatDate(dateDebut);
    }

    event.row.nature = event.row.nature == 'Encaissement' ? 1 : -1;
    if (event.row.detail) {
      const cat = this.filtredData.find((line) => {
        return (
          line.banque == event.row.bank &&
          line.nature == event.row.nature &&
          line.type == event.row.detail &&
          line.soc == event.row.soc
        );
      }).Cat;

      const params =
        dateDeb +
        ',' +
        dateFin +
        ',' +
        event.row.nature +
        ',' +
        event.row.bank +
        ',' +
        event.row.detail +
        ',' +
        event.row.soc;

      this.generaleService.dialog.open(this.details);
      this.generaleService
        .rechercheTable('apiEncFinD' + cat, params)
        .subscribe((res) => {
          if (res.length > 0) {
            this.insightDataKeys = Object.keys(res[0]);
            this.insightData = res;
            this.detailsData = {
              listBtn: [],
              displayedColumnsBrut: {},
              dataSourceBrut: [],
              heightTable: '70vh',
              colonnes: this.insightDataKeys,
              multipleSelect: false,
              api: this.generaleService.api,
              showFilter: true,
              param: 'apiEncFinD' + cat + '&param=' + params,
              dataComposant: false,
              OnSelectRowOpenMenu: true,
              listBtnRowMenu: [],
              headerHeight: '30px',
              fontSizeTitleHeader: '16px',
              rowHeight: '30px',
              footerHeight: '50px',
              hasFooter: false,
              hasVirtualScrolling: true,
              headerBackgroundColor: '#323232',
              headerTextColor: 'white',
              iconColorBeforeFilter: 'gray',
              iconColorAfterApplyFilter: 'green',
              iconColorBeforeSort: 'gray',
              headerIconsSize: '12px',
            };
          }

          if (res.length > 0)
            setTimeout(() => {
              this.tableComponent.setDataSource(res);
            }, 2000);
        });
    }
  }

  // presentDetailsModalSociete(event) {
  //   const formatDate = (date) => {
  //     return (
  //       date.getFullYear() +
  //       '' +
  //       (date.getMonth() + 1 < 10
  //         ? '0' + (date.getMonth() + 1)
  //         : date.getMonth() + 1) +
  //       '' +
  //       (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  //     );
  //   };

  //   const colDate: Date = new Date(event.col.col.title);
  //   let dateDebut = colDate;
  //   if (event.col.isEchu) {
  //     this.dateDetailsMin = this.minDateInData;
  //     this.dateDetailsMax = dateDebut;
  //     var dateDeb = formatDate(this.minDateInData);
  //     var dateFin = formatDate(colDate);
  //   } else if (this.sortBy == 'mounth') {
  //     this.dateDetailsMin = dateDebut;
  //     this.dateDetailsMax = new Date(
  //       dateDebut.getFullYear(),
  //       dateDebut.getMonth() + 1,
  //       0
  //     );
  //     var dateDeb = formatDate(dateDebut);
  //     var dateFin = formatDate(this.dateDetailsMax);
  //   } else if (this.sortBy == 'day') {
  //     this.dateDetailsMin = dateDebut;
  //     var dateDeb = formatDate(dateDebut);
  //     var dateFin = formatDate(dateDebut);
  //   }

  //   //event.row.nature = event.row.nature == 'Encaissement' ? 1 : -1;
  //   if (event.row.detail) {
  //     const cat = this.filtredData.find((line) => {
  //       return (
  //         line.banque == event.row.bank &&
  //         //line.nature == event.row.nature &&
  //         line.type == event.row.detail &&
  //         line.soc == event.row.soc
  //       );
  //     }).Cat;

  //     const params =
  //       dateDeb +
  //       ',' +
  //       dateFin +
  //       ',' +
  //       event.row.nature +
  //       ',' +
  //       event.row.bank +
  //       ',' +
  //       event.row.detail +
  //       ',' +
  //       event.row.soc;

  //     this.generaleService.dialog.open(this.details);
  //     this.generaleService
  //       .rechercheTable('apiEncFinD' + cat, params)
  //       .subscribe((res) => {
  //         if (res.length > 0) {
  //           this.insightDataKeys = Object.keys(res[0]);
  //           this.insightData = res;
  //           this.detailsData = {
  //             listBtn: [],
  //             displayedColumnsBrut: {},
  //             dataSourceBrut: [],
  //             heightTable: '70vh',
  //             colonnes: this.insightDataKeys,
  //             multipleSelect: false,
  //             api: this.generaleService.api,
  //             showFilter: true,
  //             param: 'apiEncFinD' + cat + '&param=' + params,
  //             dataComposant: false,
  //             OnSelectRowOpenMenu: true,
  //             listBtnRowMenu: [],
  //             headerHeight: '30px',
  //             fontSizeTitleHeader: '16px',
  //             rowHeight: '30px',
  //             footerHeight: '50px',
  //             hasFooter: false,
  //             hasVirtualScrolling: true,
  //             headerBackgroundColor: '#323232',
  //             headerTextColor: 'white',
  //             iconColorBeforeFilter: 'gray',
  //             iconColorAfterApplyFilter: 'green',
  //             iconColorBeforeSort: 'gray',
  //             headerIconsSize: '12px',
  //           };
  //         }

  //         if (res.length > 0)
  //           setTimeout(() => {
  //             this.tableComponent.setDataSource(res);
  //           }, 2000);
  //       });
  //   }
  // }
  closeDialog() {
    this.generaleService.dialog.closeAll();
  }
  changeSorType(type) {
    this.sortBy = type;
    this.setupLevel4();
  }
}
